// Transform Page Entry Point
import './styles/main.scss';
import { injectTransformControlsStyles } from './utils/image-transform-controls.js';
import { initTransformPage } from './transform-logic.js';

// Inject transform controls styles
injectTransformControlsStyles();

// Make initTransformPage available globally for HTML
(window as any).initTransformPage = initTransformPage;

console.log('🎨 MCP Image Transform loaded');
